import { modalZIndexService } from "../../comun/services/components/ModalZIndexService";
import { ICreateRender } from "../definitions/ICreateRender";

export abstract class BaseCreateRender implements ICreateRender {
  private readonly _element: HTMLDivElement;

  constructor() {
    this._element = document.createElement("div");
  }

  protected abstract readonly elementId: string;

  protected abstract getHtml(): string;

  protected abstract afterInit(element: HTMLDivElement): void;

  protected abstract beforeDispose(element: HTMLDivElement): void;

  protected _disposed: boolean = false;

  init(): void {
    this._element.id = this.elementId;
    this._element.innerHTML = this.getHtml();
    document.body.appendChild(this._element);
    // Apila este modal por encima de los ya abiertos (contador global).
    modalZIndexService.addZIndex();
    const overlay =
      this._element.querySelector<HTMLElement>(".sx-modal-overlay");
    if (overlay) {
      overlay.style.zIndex = String(modalZIndexService.getZIndex());
    }
    this.afterInit(this._element);
  }

  dispose(): void {
    if (this._disposed) return;

    this.beforeDispose(this._element);
    document.body.removeChild(this._element);
    modalZIndexService.removeZIndex();
    this._disposed = true;
  }
}
